import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Badge,
  Button,
  Card,
  Flex,
  Space,
  Group,
  Text,
  TextInput,
  SegmentedControl,
} from "@mantine/core";

import { PaginatedList } from "@components/shared";

export default function SurveyList({
  items = [],
  requestInfo = {
    url: `/retrieve-surveys/`,
    data: {},
  },
  refresh,
  isIndex,
}) {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    status: "1",
    search_value: "",
  });

  const reqData = {
    ...filters,
    ...requestInfo.data,
    refresh,
  };

  return (
    <div>
      {requestInfo && (
        <React.Fragment>
          <TextInput
            placeholder={t("search")}
            size="lg"
            value={filters.search_value}
            onChange={(e) =>
              setFilters({ ...filters, search_value: e.target.value })
            }
          />
          <SegmentedControl
            data={[
              { label: t("active"), value: "1" },
              { label: t("inactive"), value: "2" },
            ]}
            value={filters.status}
            onChange={(value) => setFilters({ ...filters, status: value })}
            mt="sm"
            size="xs"
          />
        </React.Fragment>
      )}
      <PaginatedList
        tableData={items}
        requestInfo={{
          url: requestInfo.url,
          data: reqData,
        }}
        responseMapping={(r) =>
          r.map((m) => ({
            ...m,
            link_url: `/surveys/${m.id}`,
          }))
        }
        displayFormatter={(item) => {
          return (
            <Card key={item.original.id}>
              <Group>
                <Text
                  c="dark"
                  fw={700}
                  component={Link}
                  to={`/surveys/${item.original.id}`}
                >
                  {item.original.name}
                </Text>
              </Group>
              <Text size="sm">
                created {new Date(item.original.created_at).toLocaleString()}
              </Text>
              <Text size="sm">{item.original.version_count} versions</Text>
            </Card>
          );
        }}
      />
    </div>
  );
}
